import { CategoriaMinuta, Minuta, Processo } from "../modelo";
import CategoriaMinutaApi from "../api/CategoriaMinutaApi";
import { runInAction } from "mobx";


class CategoriaMinutaService {
    async associarCategoriasAMinuta(processo: Processo, minuta: Minuta, categorias: CategoriaMinuta[]) {
        await CategoriaMinutaApi.associarCategoriasAMinuta(processo.identificadorProcesso, minuta.tipo.codigo, categorias);
        runInAction(() => {
            minuta.categorias = categorias;
        });
        return;
    }

    recuperarCategoriasDaMinuta(idProcesso: number, tipoMinuta: number) {
        return CategoriaMinutaApi.recuperarCategoriasDaMinuta(idProcesso, tipoMinuta);
    }
}

export default new CategoriaMinutaService();